import React from 'react'

import cn from 'classnames'

import { SiteContext } from 'context/site-context'

import Categories from 'components/sections/Categories'
import Footer from 'components/sections/Footer'
import Hero from 'components/sections/Hero'
import Header from 'components/sections/Header'

import {
  getQS,
  prettifyCity,
} from 'helpers'

import './index.scss'

const City = props => {
  const [ site ] = React.useContext(SiteContext)

  return <div className={cn('page-wrapper', {isLoadingSiteData: site.isLoadingSiteData})}>
    <Header showHeader={true} animate={false} />
    <Categories className="city-wrapper" headline={`Popular Categories in <span class="highlight">${prettifyCity(props.city)}</span>`}/>
    <Hero />
    <Footer />
  </div>
}

export default City
